import type { ModuleFile } from '../../core/modules.ts';

// Módulo «review»: manifiesto. Las pantallas se cargan de forma perezosa.
export const manifests: ModuleFile['manifests'] = [
  {
    id: 'review',
    title: 'Revisión',
    projectTab: { segment: 'revision', label: 'Revisión', order: 5 },
    load: () => import('./ReviewPage.tsx').then((m) => ({ default: m.ReviewPage })),
  },
];
